"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = void 0;
var options = {
  maintainAspectRatio: false,
  layout: {
    // if line of chart close to min/max, canvas cut it by overflow hidden
    // padding solve it
    padding: {
      top: 2,
      bottom: 2
    }
  },
  legend: {
    display: false
  },
  tooltips: {
    enabled: false
  },
  elements: {
    point: {
      radius: 0
    },
    line: {
      borderWidth: 2
    }
  },
  scales: {
    xAxes: [{
      display: false
    }],
    yAxes: [{
      display: false
    }]
  }
};
exports.options = options;